import { NotFoundError } from "@fl-purchase/core";
import { accountBloc } from "@fl-purchase/core/account";
import { userBloc } from "@fl-purchase/core/user";
import { datasource } from "react-flowder";
import { of, throwError, mergeMap, catchError } from "rxjs";

import { authorizedStream } from "./account";

const currentUserStream = authorizedStream.pipe(
  mergeMap((account) => userBloc.stream({ user: account })),
  catchError((err) => (NotFoundError.is(err) ? of(null) : throwError(() => err))),
);

const anonymsUserStream = accountBloc.stream().pipe(
  mergeMap((account) => (account !== null ? userBloc.stream({ user: account }) : of(null))),
  catchError(() => of(null)),
);

export const anonymsUserQuery = datasource(() => anonymsUserStream);
export const userQuery = datasource(() => currentUserStream);
export const userCommand: Omit<typeof userBloc, "stream"> = userBloc;

export type UserQuery = typeof userQuery;
export type UserCommand = typeof userCommand;
